import { getVisitorId } from "./visitorSession";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";

export type SubmittedPoints = {
  userId: string;
  points: number;
  rank: number;
  total: number;
};

type PointsResponse = { status: string; result: SubmittedPoints };

export async function submitTotalPoints(points: number) {
  const response = await fetch(`${API_BASE_URL}/api/points`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ userId: getVisitorId(), points: Math.max(0, points) }),
  });

  if (!response.ok) throw new Error(`Submitting points failed with status ${response.status}`);
  return (await response.json() as PointsResponse).result;
}
